import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AcceptInvitationStepBase } from '../../shared/accept-invitation-step-base/accept-invitation-step-base';

@Component({
  selector: 'app-request-credit-line',
  templateUrl: './request-credit-line.component.html',
  styleUrl: './request-credit-line.component.scss'
})
export class RequestCreditLineComponent extends AcceptInvitationStepBase<any> {
  public override readonly nextUrl = '../about-business';
  public override readonly previousUrl = '../personal-details';
  public readonly form: FormGroup = inject(FormBuilder).group({
    requestedAmount: [null, [Validators.min(5000), Validators.max(250000)]]
  });
  public override readonly storageKey = 'creditLineForm';
}
